import React from "react";
import Button from "b2b-ui-components-lib/lib/components/button";
import "./downloadExcel.scss";

const downloadExcel = ({ title, body, isLoading, buttonText, onClick }) => {
  return (
    <div className="config_content">
      <h5> {title}</h5>
      <p> {body}</p>
      <div className="config_button">
        <Button disabled={isLoading} onClick={onClick}>
          {buttonText}
          <span className="material-icons-outlined" style={{
            top: 2,
            left: 10
          }}>file_download</span>
          { isLoading && <span className="loading_icon"></span> }
        </Button>
      </div>
    </div>
  );
};

export default downloadExcel;
